<template>
    <div class="relative bg-blue-50 overflow-hidden">
        <!-- Fondo y Hero Section -->

        <div class="flex flex-row items-center bg-blue-900 pt-16 pb-24 w-full px-4 sm:px-6 lg:px-8 relative z-10">
            <!-- Contenedor para el título y el párrafo -->
            <div class="flex-1">
                <h1 class="text-5xl font-extrabold font-serif text-white sm:text-5xl animated-title">
                    Forma Parte del <span class="text-5xl text-yellow-500">Club de Negocios </span>
                </h1>
                <p class="mt-8 text-lg text-blue-300 ">
                    Únete a nuestra comunidad y descubre cómo aumentar tus ventas, recibir
                    mayor exposición publicitaria
                    y generar ingresos adicionales de manera fácil e inteligente con la iniciativa ciudades con vida
                    digna. 💼✨<br>
                    ¡Es momento de llevar tu negocio al siguiente nivel con <span class="font-extrabold">Virtual
                        Shopping Club!</span>
                </p>
                <router-link :to="registroRoute" class="mt-6 inline-block px-8 py-3 bg-blue-800 text-white font-bold rounded-full
                                      hover:bg-green-600 hover:text-white transition-all duration-300 animate__animated
                                      animate__zoomInDown animate__slower">
                    ¡Regístrate Gratis!
                </router-link>
            </div>
            <!-- Imagen al lado derecho -->
            <img src="@/assets/img/members/negocios2.png" alt="publicidad"
                class="w-40 h-40 animate__animated animate__zoomInLeft">
        </div>

        <!-- Video de YouTube -->
        <div data-aos="zoom-in-right" class="mx-auto max-w-4xl px-6 lg:px-8 pt-12 pb-12">
            <div class="aspect-w-16 aspect-h-9">
                <iframe class="absolute rounded-lg  top-0 left-0 w-full h-full"
                    src="https://www.youtube.com/embed/M4o5Zc7c3fQ" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
        </div>

        <!-- Ciudades con vida digna -->
        <section class="bg-blue-50 text-blue-900 py-16 px-4 md:px-16 animate-fade-in">
            <div class="max-w-6xl mx-auto text-center">
                <h2 class="text-4xl md:text-5xl font-bold mb-6 animate-slide-in-down">
                    <span class="text-4xl">Aprovecha la iniciativa</span> "Ciudades con Vida Digna"
                </h2>
                <p class="text-xl md:text-2xl font-medium mb-12 animate-fade-in delay-200">
                    Yatvii S de R.L. empresa socialmente responsable a iniciado una inversión histórica para transformar
                    miles de negocios
                    con la campaña de cupones de descuentos para el fortalecimiento del comercio local y
                    el empoderamiento del consumidor.
                </p>

                <h1 class="text-3xl font-bold mb-2">A Nivel Nacional</h1>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16 animate-slide-in-up">
                    <div data-aos="fade-up" class="bg-white rounded-2xl shadow-lg p-6 border-l-8 border-blue-500">
                        <p class="text-4xl font-bold text-blue-700">245</p>
                        <p class="text-lg">📍 Zonas en todo México</p>
                    </div>
                    <div data-aos="fade-up" class="bg-white rounded-2xl shadow-lg p-6 border-l-8 border-blue-500">
                        <p class="text-4xl font-bold text-blue-700">+122,500</p>
                        <p class="text-lg">💼 Negocios patrocinados</p>
                    </div>
                    <div data-aos="fade-up" class="bg-white rounded-2xl shadow-lg p-6 border-l-8 border-blue-500">
                        <p class="text-4xl font-bold text-blue-700">$465M - $1.22B</p>
                        <p class="text-lg">💰 Inversión total (MXN)</p>
                    </div>
                </div>

                <div data-aos="fade-up"
                    class="w-full max-w-3xl mx-auto bg-white rounded-xl flex justify-center items-center mb-16">
                    <img src="@/assets/img/inversion.jpg" alt="VSC" class="w-full md:w-3/4 h-auto rounded-lg" />
                </div>

                <h1 class="text-3xl font-bold mb-2">A Nivel Ciudad o Zona</h1>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16 animate-slide-in-up">
                    <div data-aos="fade-up-left" class="bg-white rounded-2xl shadow-lg p-6 border-l-8 border-blue-500">
                        <p class="text-4xl font-bold text-blue-700">500</p>
                        <p class="text-lg">💼 Negocios patrocinados aproximadamente</p>
                    </div>
                    <div data-aos="fade-up-right" class="bg-white rounded-2xl shadow-lg p-6 border-l-8 border-blue-500">
                        <p class="text-4xl font-bold text-blue-700">$1.9M a $5M</p>
                        <p class="text-lg">💰 De inversión por ciudad</p>
                    </div>
                </div>

                <section class="flex items-center justify-center">
                    <div class="max-w-4xl w-full rounded-2xl">
                        <h2 class="text-3xl font-bold text-center mb-6">
                            ¡Aprovecha los Patrocinios que Yatvii tiene para ti!
                        </h2>
                        <p class="text-xl text-center mb-8">
                            En el inicio de la campaña de cupones en tu zona que tiene un valor <span class="font-semibold">$10,000 MXN</span>. Yatvii ofrece patrocinios especiales. 
                        </p>

                        <div class="grid md:grid-cols-2 gap-6">
                            <!-- 90% Patrocinio -->
                            <div data-aos="fade-up" class="rounded-xl p-6 text-center">
                                <h3 class="text-xl font-bold text-green-700">90% Patrocinio</h3>

                                <p class="text-lg font-semibold text-gray-800">Aporte del negocio: <span
                                        class="text-green-700">$1,000</span></p>
                            </div>

                            <!-- 50% Patrocinio -->
                            <div data-aos="fade-up" class="rounded-xl p-6 text-center">
                                <h3 class="text-xl font-bold text-green-700">50% Patrocinio</h3>
                                <p class="text-lg font-semibold text-gray-800">Aporte del negocio: <span
                                        class="text-green-700">$5,000</span></p>
                            </div>
                        </div>
                        <p class="text-2xl md:text-2xl font-medium mb-2 mt-4 animate-fade-in delay-500">
                            ¿Qué tienen que hacer los negocios?
                        </p>
                        <ul class="text-xl mb-12 animate-fade-in delay-500">
                            <li>1. Cubrir aportación (Con o Sin patrocinio)</li>
                            <li>2. Desear tener $1,000,000 en ventas o en beneficios</li>
                            <li>3. Otorgar <strong>descuentos</strong> desde el 10% a miembros del club</li>
                        </ul>
                    </div>
                </section>

                <div data-aos="zoom-out-up">
                    <router-link :to="registroRoute"
                        class="bg-blue-600 gradient-bg text-white text-xl font-semibold py-3 px-8 rounded-full ">
                        ✨ Postula tu negocio ahora
                    </router-link>
                </div>
            </div>
        </section>

        <div class="bg-gradient-to-r from-blue-50 via-blue-400 to-blue-50 pt-2 pb-2">
        </div>


        <div class="mt-14 mb-14">
            <h2 class="text-3xl font-serif font-extrabold text-center animated-gradient">
                "Lleva tu negocio al siguiente nivel con Virtual Shopping Club"
            </h2>
        </div>

        <div class="bg-gradient-to-r from-blue-50 via-blue-400 to-blue-50 pt-2 pb-2">
        </div>

        <!-- Sección de Beneficios -->
        <div class="bg-blue-50 py-16">
            <div class="max-w-7xl mx-auto px-6 lg:px-8">
                <h2 class="text-4xl font-serif font-extrabold text-center text-blue-900 mb-8">
                    En Virtual Shopping Club los negocios obtienen:
                </h2>

                <div class="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                    <div data-aos="fade-up"
                        class="flex flex-col items-center text-center bg-blue-100 p-6 rounded-lg shadow-lg shadow-blue-500 border border-blue-300 transform hover:scale-105 transition-all duration-300 ease-in-out">
                        <h3 class="text-2xl font-serif font-semibold text-blue-800">PUBLICIDAD</h3>
                        <img src="@/assets/img/publicidad.png" alt="Icono de publicidad" class="h-16 mx-auto mb-4">
                        <p class="mt-1 text-gray-700" style="text-align: justify;">
                            Publicidad de su marca dentro de nuestra aplicación con renovación anual.
                        </p>
                    </div>
                    <div data-aos="fade-up"
                        class="flex flex-col items-center text-center bg-blue-100 p-6 rounded-lg shadow-lg shadow-blue-500 border border-blue-300 transform hover:scale-105 transition-all duration-300 ease-in-out">
                        <h3 class="text-2xl font-serif font-semibold text-blue-800">VENTAS EFECTIVAS</h3>
                        <img src="@/assets/img/VentasEfect.png" alt="Icono depublicidad" class="h-16 mx-auto mb-4">
                        <p class="mt-1 text-gray-700" style="text-align: justify;">
                            Ventas efectivas con los miembros del club en su establecimiento.
                        </p>
                    </div>
                    <div data-aos="fade-up"
                        class="flex flex-col items-center text-center bg-blue-100 p-6 rounded-lg shadow-lg shadow-blue-500 border border-blue-300 transform hover:scale-105 transition-all duration-300 ease-in-out">
                        <h3 class="text-2xl font-serif font-semibold text-blue-800">INGRESOS EXTRA</h3>
                        <img src="@/assets/img/ingresosExt.png" alt="Icono de publicidad"
                            class="w-16 h-16 mx-auto mb-4">
                        <p class="mt-1 text-gray-700" style="text-align: justify;">
                            Un sistema para generar ganancias adicionales, que pueden hacer crecer tu negocio.
                        </p>
                    </div>
                    <div data-aos="fade-up"
                        class="flex flex-col items-center text-center bg-blue-100 p-6 rounded-lg shadow-lg shadow-blue-500 border border-blue-300 transform hover:scale-105 transition-all duration-300 ease-in-out">
                        <h3 class="text-2xl font-serif font-semibold text-blue-800">SER PARTE DE LA COMUNIDAD DE VSC
                        </h3>
                        <img src="@/assets/img/comunidad.png" alt="Icono de publicidad" class="h-16 mx-auto mb-4">
                    </div>
                    <div data-aos="fade-up"
                        class="flex flex-col items-center text-center bg-blue-100 p-6 rounded-lg shadow-lg shadow-blue-500 border border-blue-300 transform hover:scale-105 transition-all duration-300 ease-in-out">
                        <h3 class="text-2xl font-serif font-semibold text-blue-800">PROVEEDOR DE LA COMUNIDAD EN
                            EXPANSIÓN VSC
                        </h3>
                        <img src="@/assets/img/proveedor.png" alt="Icono de publicidad" class="h-16 mx-auto mb-4">
                    </div>
                    <div data-aos="fade-up"
                        class="flex flex-col items-center text-center bg-blue-100 p-6 rounded-lg shadow-lg shadow-blue-500 border border-blue-300 transform hover:scale-105 transition-all duration-300 ease-in-out">
                        <h3 class="text-2xl font-serif font-semibold text-blue-800">POSIBILIDAD DE SER PATROCINADOR F3
                        </h3>
                        <img src="@/assets/img/F3.png" alt="Icono de publicidad" class="w-16 h-16 mx-auto mb-4">
                    </div>
                </div>
            </div>
        </div>

        <!-- Sección de Tecnologia -->
        <div class="py-16 bg-blue-50">
            <h2 class="text-4xl font-serif font-bold text-center text-blue-900 mb-12">
                Tambien obtienes acceso a <span class="text-yellow-400 font-bold">3 tecnologías
                    exclusivas</span> que impulsarán tu negocio:
            </h2>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto px-6 lg:px-12">
                <div data-aos="zoom-in-left"
                    class="bg-white border-l-10 border-blue-500 p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition">
                    <h3 class="text-2xl font-serif font-semibold text-blue-900">🎟️ Campaña de cupones</h3>
                    <p class="mt-2 text-gray-700">
                        Con nuestras campañas tendrás una forma muy efectiva de atraer nuevos clientes, dar a conocer tu
                        negocio y potencializar tus ventas efectivas.
                    </p>
                </div>

                <div data-aos="zoom-in-right"
                    class="bg-white border-l-10 border-blue-500 p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition">
                    <h3 class="text-2xl font-serif font-semibold text-blue-900">🏆 Centro de canje de puntos</h3>
                    <p class="mt-2 text-gray-700">
                        Al ser tu negocio un centro de canje de puntos vas a obtener clientes fieles, tecnificación de
                        tu negocio y ventaja competitiva con negocios externos.
                    </p>
                </div>

                <div data-aos="zoom-in-left"
                    class="bg-white border-l-10 border-blue-500 p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition">
                    <h3 class="text-2xl font-serif font-semibold text-blue-900">🤝 Patrocinador F3</h3>
                    <p class="mt-2 text-gray-700">
                        Una tecnología solo para <span class="font-semibold text-blue-800">miembros fundadores</span>
                        con la cual podras recibir ingresos pasivos por las ventas y cupones aplicados en la zona de tu
                        ciudad de residencia.
                    </p>
                </div>
            </div>
        </div>


        <div class="vsc bg-linear-to-r from-blue-300 via-green-300 to-blue-300 mb-10 pt-6 pb-6">
            <h1 class="text-gray-800 text-3xl font-serif font-extrabold text-center">
                Obtén ganancias residuales de pesitos a ganancias ilimitadas con el Programa Fusión
            </h1>
        </div>

        <!-- Membresia y Programa f3 -->
        <div class=" max-w-4xl mx-auto text-center bg-orange-500 rounded-lg p-6 mt-2 bg-cover bg-center"
            :style="{ backgroundImage: `url(${require('@/assets/img/fondoAzul.png')})` }">
            <div data-aos="zoom-in" class="max-w-7xl mx-auto px-6 lg:px-8">
                <img src="@/assets/img/cardVSC.png" alt="Icono de publicidad" class="w-75 h-54 mx-auto mb-5">
                <h2 class="neon-black text-3xl font-serif font-extrabold text-center text-white mb-5 ">
                    Únete al club y aumenta tus ventas
                </h2>
                <p class="neon-black text-white text-lg leading-relaxed mb-12">
                    Como miembro del Club de Negocios, convierte tu marca en la favorita de nuestros clientes, con la
                    membresia anual
                    tu negocio tendrá mayores beneficios en publicidad, ventas efectivas,
                    ingresos extras y acceso a <span class="font-semibold">2 tecnologias</span> como la
                    campaña de cupones y ser centro de canje de puntos, las cuales te ayudarán a incrementar tus
                    ganacias desde
                    pesitos a más
                    de $1,000,000 en ventas efectivas.
                    Aparte, contarás con
                    el apoyo de un experto en ventas y marketing. <br><br>
                </p>

                <h2 class="neon-black text-3xl font-serif font-extrabold text-center text-white mb-5 ">
                    Convierte en <span class="text-cyan-500">miembro Fundador</span> del club de negocios
                </h2>
                <p class="neon-black text-white text-lg leading-relaxed mb-12">
                    <span class="font-bold">🎁 Sé de los primeros 100 negociós de la zona en unirse</span><br>
                    Obtén de cortesía la tecnologia F3 con la cual podrás recibir ingresos <span
                        class="font-semibold text-green-500">pasivos</span> de todas las <span
                        class="font-semibold text-green-500">ventas y cupones</span> aplicados en negocios
                    afiliados de una zona de México. No tienes que vender nada, solo aprovechar el
                    movimiento de la red de negocios. ¡Así de fácil! 💰🚀
                </p>

                <router-link :to="registroRoute" class="inline-block px-8 py-3 bg-white text-blue-700 font-bold text-lg rounded-lg
                                    shadow-lg hover:bg-green-600 hover:text-white transform hover:scale-105
                                    transition-all duration-300 mb-6">
                    ¡Aprovecha esta oferta exclusiva!
                </router-link>
            </div>
        </div>



        <!-- Llamada a la acción -->
        <div class="bg-linear-to-l  py-16 relative z-20 mt-14">
            <!-- Preguntas Frecuentes (FAQ) -->
            <div class="bg-blue-50 max-w-4xl mx-auto p-6  rounded-lg shadow-lg mb-16">
                <div class=" p-6 rounded-lg text-center text-white">
                    <h3 class="text-gray-800 text-3xl font-bold">Preguntas Frecuentes</h3>
                </div>
                <div id="faqApp" class="mt-6">
                    <div v-for="(faq, index) in faqs" :key="index" class="border-b border-gray-500 py-4">
                        <button @click="toggleFAQ(index)"
                            class="w-full text-left font-semibold text-lg flex justify-between">
                            {{ faq.question }}
                            <span class="text-gray-800">{{ faq.open ? "−" : "+" }}</span>
                        </button>
                        <p v-if="faq.open" class="mt-2 text-gray-700">{{ faq.answer }}</p>
                    </div>
                </div>
            </div>

            <div class="max-w-7xl mx-auto text-center px-4 sm:px-6 lg:px-8">
                <h2 class="text-4xl text-yellow-400 font-serif font-extrabold text-white animate-pulse">
                    ¡Únete Hoy y Lleva Tu Negocio Al Siguiente Nivel!
                </h2>
                <img src="@/assets/img/vsc.png" alt="publicidad" class="w-40 h-30 mx-auto mt-4">
                <p class="text-lg text-blue-100 mt-8 mb-8">
                    Regístrate y comienza a disfrutar de todos los beneficios exclusivos para miembros del Club de
                    Negocios.
                </p>
                <router-link :to="registroRoute"
                    class="inline-block px-8 py-4 bg-blue-600 text-white font-bold text-lg rounded-full
                                      shadow-lg hover:bg-green-500 transform hover:scale-105 transition-all duration-300">
                    ¡Empieza hoy mismo!
                </router-link>
            </div>
        </div>
        <patrocinadores-comp :patrocinadores="patrocinadores" v-if="patrocinadores.length > 0"></patrocinadores-comp>
    </div>
</template>

<script>
import patrocinadoresComp from "@/components/campanias/patrocinadores";

export default {
    name: 'ClubNegocios',
    data() {
        return {
            faqs: [
                { question: "¿Qué necesito para unirme al club?", answer: "Solo necesitas tener un negocio físico, una actitud amable y de servicio, ¡y listo! obtén tu membresía y empieza a disfrutar de los beneficios..", open: false },
                { question: "¿Qué negocios pueden participar?", answer: "¡Cualquiera! No importa si vendes un producto o prestas un servicio, puedes unirte al club. Lo único que necesitas es que tu negocio sea legal y pueda emitir facturas.", open: false },
                { question: "¿Dónde se mostrará la publicidad de mi negocio?", answer: "Si eres uno de los primeros 100 negocios de la zona en unirte, tendrás prioridad para aparecer en nuestra aplicación. Además, podrás tener la oportunidad de figurar en presentaciones virtuales, campañas publicitarias o material promocional.", open: false },
                { question: "No sé mucho de marketing, ¿es necesario para unirme al club?", answer: "¡Para nada! No importa si eres experto en marketing o no. Aquí trabajarás con un experto que te ayudará con las ventas, publicidad y hacer crecer tus contactos.", open: false },
            ]
        }
    },
    components: {
        patrocinadoresComp
    },
    methods: {
        toggleFAQ(index) {
            this.faqs[index].open = !this.faqs[index].open
        }
    },
    props: {
        patrocinadores: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        registroRoute() {
            return typeof this.$route.params.codigo !== 'undefined' ? `/registro/campania/${this.$route.params.codigo}` :
                '/registro'
        }
    }
}
</script>

<style scoped>
/* Estilos personalizados */
.neon-text {
    text-shadow: 0 0 90px #ffffff, 0 0 20px #ffffff, 0 0 30px #ffffff;
}

.neon-black {
    text-shadow: 0 0 10px #000000, 0 0 10px #000000, 0 0 20px #000000;
}

/*Animacion Titulo*/
.animated-title {
    animation: slideIn 1.5s ease-in-out;
}

@keyframes slideIn {
    0% {
        opacity: 0;
        transform: translateY(50px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.animated-gradient {
    animation: pulse 2s infinite;
    font-size: 2rem;
    /* Ajusta el tamaño */
    font-weight: 800;
    /* Fuente extrabold */
    text-align: center;
    /* Centrar texto */
    background: linear-gradient(90deg, #2f899f, #2327dc, #2f899f);
    /* Gradiente de 3 colores */
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    /* El gradiente aparecerá en lugar del color sólido */
    animation: gradient-animation 3s infinite;
    /* Añade la animación */
}

@keyframes gradient-animation {

    0%,
    100% {
        background-position: 0% 50%;
        transform: scale(0.8);
    }

    50% {
        background-position: 100% 50%;
        transform: scale(0.9);
    }
}

.bg-blue-900 {
    background-color: #1c3d5a;
    /* Azul oscuro para el fondo del hero */
}

.bg-blue-100 {
    background-color: #f2fbff;
    /* Azul claro para tarjetas */
}

.transition-all {
    transition: all 0.3s ease;
    /* Transición suave */
}

.hover\:scale-105:hover {
    transform: scale(1.05);
    /* Escala en hover para las tarjetas */
}

.bg-linear-to-l {
    background: linear-gradient(to right, #0873e5, #3fcbe0);
    /* Gradiente atractivo para fondo */
}

/* Estilo adicional para pantallas pequeñas */
@media (max-width: 568px) {
    .vsc {
        padding: 0.5rem;
    }

    .vsc h1 {
        font-size: 1.2rem;
    }
}

/* Estilo de la nueva seccion de inversion */
@keyframes fade-in {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.animate-fade-in {
    animation: fade-in 1s ease-out forwards;
}

@keyframes slide-in-down {
    from {
        opacity: 0;
        transform: translateY(-40px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.animate-slide-in-down {
    animation: slide-in-down 1s ease-out forwards;
}

@keyframes slide-in-up {
    from {
        opacity: 0;
        transform: translateY(40px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.animate-slide-in-up {
    animation: slide-in-up 1s ease-out forwards;
}

.delay-200 {
    animation-delay: 0.2s;
}

.delay-500 {
    animation-delay: 0.5s;
}

.delay-700 {
    animation-delay: 0.7s;
}

.gradient-bg {
    background: linear-gradient(45deg, #0073ff, #12ebeb, #2174da, #12ebeb);
    background-size: 400% 400%;
    animation: gradientChange 4s ease infinite;
}
</style>